export function toggleArrayValue(array: any[], value: any) {
  return array.includes(value)
    ? array.filter((x) => x !== value)
    : [...array, value];
}
